export default __webpack_public_path__ + "static/media/Path3411.760e0532.svg";